import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import {LoginComponent} from '../app/login/login.component';
import {MapsComponent} from '../app/maps/maps.component';
import {RegistrarComponent} from '../app/registrar/registrar.component';
import {LayoutComponent} from '../app/layout/layout/layout.component';
import { AuthGuard } from './guardia/auth.guard';
import {CerrarComponent} from './cerrar/cerrar.component';
import {ErrorComponent} from './error/error.component';
import {RecuperarComponent} from './recuperar/recuperar.component';
import { LoginvotoComponent } from './loginvoto/loginvoto.component';
import { LoginappComponent } from './loginapp/loginapp.component';

const routes: Routes = [
    { path: '', redirectTo: 'login' ,pathMatch: 'full',},
    { path: 'login', component: LoginComponent },
    { path: 'loginvoto', component: LoginvotoComponent },
     { path: 'loginapp', component: LoginappComponent },
    {path:'maps',component:MapsComponent},
    {path:'registrar',component:RegistrarComponent},
    {path:'cerrar',component:CerrarComponent},
    {path:'recuperar',component:RecuperarComponent},
    {
      path:'inicio',
      component:LayoutComponent,
      canActivate: [AuthGuard],

      children: [
        {
          path: '',
          loadChildren: () => import('./view/base.module').then(m=>m.BaseModule),
          canActivate: [AuthGuard],

        },
      ]
  },{
    component: ErrorComponent,
    path: "**",
 },
];
@NgModule({
  imports: [RouterModule.forRoot(routes, {
 //   scrollPositionRestoration: 'enabled', // Add options right here
    scrollPositionRestoration: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {


 }
